<div id="customer-sidebar" class="sidebar-wrapper" [ngClass]="{ 'side-panel-notes': openNotesTab }">
  <!-- baseZIndex="100" -->
  <p-sidebar styleClass="p-sidebar-md" dismissible="false" blockScroll="false" cache="false" [showCloseIcon]="false"
    [dismissible]="false" [(visible)]="sideBarVisible" (onHide)="handleHideSidebar()" position="right">
    <div class="sidebar-container" #sidebarContainer>
      <div *ngIf="!openNotesTab">
        <i id="sidebar-close-icon" class="fal fa-times sidebar-close-icon" (click)="handleCloseSidebar()"></i>

        <div class="flex-between-center width-95p my-2">
          <div class="flex-start-center">
            <div class="flex-start-center sidebar-customer-name pointer ml-1 customer-center-hover"
              (click)="navigateToCustomerCenter()">
              <i class="pr-2 far {{ customer?.isFleetCustomer ? 'fa-cars' : 'fa-user' }}"></i>
              <span class="pr-6p text-truncate font-20 font-bold text-truncate"
                [ngClass]="{ 'text-ellipse': customer?.fullName?.length >= 35 }">
                {{ customer?.fullNameQBO }}
              </span>

              <i class="fal fa-external-link font-bold"></i>
            </div>
            <span class="font-primary font-18 font-600 ml-1">
              (Available credit: {{totalAvailableCredit || 0 | currency : usd }})
            </span>
          </div>

          <div class="d-flex">
            <span *ngIf="isChargeAccountEnabled">
              <app-switch-pill id="sidebar-customer-active-switch" position="end" tooltipPosition="top"
                [label]="'Charge Account'"
                [pTooltip]="customer?.isFleetCustomer ? 'Fleet customers cannot be marked as non-charge' : ''"
                [isActive]="customer?.chargeAccountEnable ? true : false"
                [disabled]="customer?.isFleetCustomer || !isArAccountPermitted"
                (appChange)="handleSwitchChange('chargeAccount', $event)">
              </app-switch-pill>
            </span>

            <app-switch-pill id="sidebar-customer-charge-account-switch" position="end"
              [label]="customer?.isActive ? 'Active' : 'Inactive'" [isActive]="customer?.isActive" p
              (appChange)="handleSwitchChange('active', $event)">
            </app-switch-pill>
          </div>
        </div>

        <!-- Chat icon -->
        <div *ngIf="isChatEnabled" class="flex-end-center chat-btn">
          <button class="btn btn-primary btn-submit font-12" (click)="navigateToChat()">
            <i class="fal fa-comment-dots mr-4p"></i>
            <span class="font-bold">&nbsp;Chat</span>
          </button>
        </div>
        <p-tabView class="tab-panel-underline sidebar-scroll tab-panel-default" (onChange)="handleTabChange($event)"
          [activeIndex]="index">
          <p-tabPanel id="sidebar-tab-personal" header="Contact">
            <ng-template pTemplate="content">
              <app-customer-update [errors]="errors" [isFieldsMissing]="isFieldsMissing"
                [contactValidation]="contactValidation" [isMarketingEnabled]="isMarketingEnabled"
                [defaultCustomer]="defaultCustomer" [roOpenAction]="roOpenAction"
                [defaultCustomerChargeAccountState]="defaultCustomerChargeAccountState"
                [qboTaxExemptReasons]="qboTaxExemptReasons" [isLoadingAppointment]="isLoadingAppointment"
                [openTaxExemptDropdown]="openTaxExemptDropdown" [openPreferredLocation]="openPreferredLocation"
                [highLightedCustomerNotes]="highLightedCustomerNotes" [customerId]="customer?._id" [customer]="customer"
                [estimate]="estimate" [tags]="tags" [vehicles]="vehicles" [appointments]="customerAppts"
                [isMyFleetCenterEnabled]="isMyFleetCenterEnabled" (customerDetails)="customerDetails($event)"
                (customerUpdate)="updateCustomerList($event)" [companyLocalization]="companyLocalization"
                (appUpdateCustomerTagList)="updateCustomerTagList($event)"
                (setContactValidation)="setContactValidation()">
              </app-customer-update>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel id="sidebar-tab-vehicle" header="Vehicles">
            <ng-template pTemplate="content">
              <app-vehicle-side-list [isTireStorageEnabled]="isTireStorageEnabled"
                [isMotorLookupEnabled]="isMotorLookupEnabled" [totalRecords]="totalRecords"
                [defaultMileageUnit]="defaultMileageUnit" [defaultRegState]="defaultRegState"
                [defaultRegStateCode]="defaultRegStateCode" [vehicleOdmHistory]="vehicleOdmHistory"
                [isCarfaxEnabled]="isCarfaxEnabled" [vehicleSearchPlaceholder]="vehicleSearchPlaceholder"
                [isLoadingAppointment]="isLoadingAppointment" [openConnectMotor]="openConnectMotor"
                [highLightedVIN]="highLightedVIN" [highLightedMiles]="highLightedMiles" [drivers]="vehicleDrivers"
                [highLightedVehicleId]="highLightedVehicleId" [isVehiclesLoading]="isVehiclesLoading"
                [defaultVehicles]="defaultVehicles" [vehicles]="vehicles" [vehicleColors]="vehicleColors"
                [driveTypes]="driveTypes" [vehicleTags]="vehicleTags" [appts]="customerAppts" [user]="customer"
                [customer]="customer" (getCustomerVehicle)="getVehicle()" (updateTags)="updateTags($event)"
                (updateTagList)="updateTagList($event)" (updateVehicleConnectedStatus)="updateVehicleConnectedStatus()"
                (vehicleUpdate)="getVehicleUpdate($event)">
              </app-vehicle-side-list>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel id="sidebar-driver-vehicle" header="Drivers"
          *ngIf="isMyFleetCenterEnabled && customer?.isFleetCustomer">
            <ng-template pTemplate="content">
              <app-driver-side-list [vehicles]="vehicles" [drivers]="drivers" [estimate]="estimate"
                [appointments]="customerAppts" [isMarketingEnabled]="isMarketingEnabled"
                [isLoadingAppointment]="isLoadingAppointment" [customer]="customer">
              </app-driver-side-list>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel *ngIf="isDeferredServiceEnabled" id="sidebar-tab-deferred" header="Deferred">
            <ng-template pTemplate="content">
              <app-deferred-service-sidelist [shopsMap]="shopsMap" [isMultiLocationEnabled]="isMultiLocationEnabled"
                [customerId]="customer?._id" [totalRecords]="totalRecords" [vehicles]="vehicles"
                [customerData]="customer">
              </app-deferred-service-sidelist>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel id="sidebar-tab-estimate" header="Repair order">
            <ng-template pTemplate="content">
              <app-customer-estimate [shopsMap]="shopsMap" [isMultiLocationEnabled]="isMultiLocationEnabled"
                [customerData]="customer" [vehicles]="vehicles"> </app-customer-estimate>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel id="sidebar-tab-inspection" header="Inspections">
            <ng-template pTemplate="content">
              <app-customer-inspections [shopsMap]="shopsMap" [isMultiLocationEnabled]="isMultiLocationEnabled"
                [isLoadingAppointment]="isLoadingAppointment" [customerData]="customer" [vehicles]="vehicles"
                [appts]="customerAppts">
              </app-customer-inspections>
            </ng-template>
          </p-tabPanel>

          <p-tabPanel id="sidebar-tab-credit-memo" header="Finances" *ngIf=" isChargeAccountEnabled">
            <ng-template pTemplate="content">
              <div class="finance-tab">
                <div class="tab-wrap">
                  <div class="finance-btn pointer" [ngClass]="{'active': financeTab === 1}"
                    (click)="handleFinanceTab(1)">
                    <i class="fal fa-window-frame"></i>
                    Credit Memo
                  </div>
                  <div class="finance-btn pointer" tooltipPosition="top"
                    [pTooltip]="!customer?.chargeAccountEnable ? 'AR account management is only available for charge customers' : ''"
                    [ngClass]="{'active': financeTab === 2, 'div-disabled pointer-event': !customer?.chargeAccountEnable }"
                    (click)="handleFinanceTab(2)">
                    <i class="fal fa-window-frame"></i>
                    AR Account
                  </div>
                </div>
              </div>
              <div *ngIf="financeTab === 1">
                <app-customer-credit-memo [customerData]="customer" [estimate]="estimate" [creditMemos]="creditMemo"
                  [totalCreditMemoRecords]="totalCreditMemoRecords" [totalAvailableCredit]="totalAvailableCredit"
                  (creditMemoUpdate)="getAllCreditMemo(customerId, true)">
                </app-customer-credit-memo>
              </div>
              <div *ngIf="financeTab === 2 && customer?.chargeAccountEnable">
                <app-ar-account [isCustomerPaymentEnabled]="isCustomerPaymentEnabled"
                  [isArAccountPermitted]="isArAccountPermitted" [customerData]="customer" [estimate]="estimate"
                  [chargeAccounts]="chargeAccounts" [currentShopId]="currentShopId"></app-ar-account>
              </div>
            </ng-template>
          </p-tabPanel>

          <!-- Old tab panel -->
          <p-tabPanel id="sidebar-tab-credit-memo" header="Credit Memo" *ngIf="!isChargeAccountEnabled">
            <ng-template pTemplate="content">
              <app-customer-credit-memo [customerData]="customer" [estimate]="estimate" [creditMemos]="creditMemo"
                [totalCreditMemoRecords]="totalCreditMemoRecords" [totalAvailableCredit]="totalAvailableCredit"
                (creditMemoUpdate)="getAllCreditMemo(customerId, true)"></app-customer-credit-memo>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>

      <div class="sidebar-notes-container" *ngIf="openNotesTab">
        <i id="notes-close-icon" class="fal fa-times notes-close-icon" (click)="handleCloseSidebar()"></i>

        <div class="flex-between-center width-93p">
          <div class="flex-start-center">
            <div class="flex-start-center sidebar-customer-notes pointer">
              <div class="notes-circle">
                <i class="far fa-file-alt notes-icon font-18"></i>
              </div>
              <div class="notes-heading-wrapper">
                <h2 class="font-black font-bold notes-heading mb-0 one-line-elipsis">
                  {{ notePanelData?.title }}
                </h2>
                <h3 *ngIf="notePanelData?.subTitle" class="font-black notes-heading sub-title mb-0 one-line-elipsis">
                  {{ notePanelData?.subTitle }}
                </h3>
              </div>
            </div>
          </div>
        </div>

        <hr class="notes-underline" />

        <div class="notes-textarea">
          <app-textarea class="cursor-text" type="text" name="notes" textAreaId="" styleClassLabel="cursor-text"
            styleClass="service-notes" styleClassInput="" theme="light"
            [placeholder]="[displayExternalServiceNotes ? 'Service notes (external)' : notePanelData.subTitle ? 'Enter line item description' : 'Service notes (internal)']"
            [rows]="1" [hasHoverEffect]="false" [autoGrow]="true" [maxAutoGrowHeight]="810"
            [value]="notePanelData?.notes" [maxLength]="10000" [fontSize]="14" (appFocus)="handleFocus('notes')"
            (appChange)="handleChange('notes', $event)">
          </app-textarea>
        </div>

        <div class="set-notes-dialog-footer flex-end-center">
          <button class="btn btn-border pointer btn-submit mr-2" (click)="handleCloseSidebar()">Cancel</button>
          <button class="btn btn-primary btn-submit mr-2" (click)="saveNotes()" [disabled]="isFinalizedRo"
            [pTooltip]="isFinalizedRo && 'Sorry, cannot make any changes to a finalized RO'">Save</button>
        </div>
      </div>
    </div>
  </p-sidebar>
</div>
